export enum SettingsAppsDataEventObjectsEnum {
  APP_REQUEST_FEEDBACK = 'app_request_feedback',
  APP_STORE_REQUEST = 'app_store_request',
}
